export const loadState = () => {
  try {
    const serializedState = localStorage.getItem("state");
    if (!serializedState) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    console.error("Failure in loadState", err);
    return undefined;
  }
};

export const saveState = (state: any) => {
  try {
    const stateToPersist = {
      ...state,
      agent: {
        ...state.agent,
        // Don't persist modal/sidebar state
        employeeProfileSidebar: undefined,
        documentPreviewModal: undefined,
      },
    };
    const serializedState = JSON.stringify(stateToPersist);
    // console.log("[localStorage] state length: ", serializedState.length);
    // const byteSize = new Blob([serializedState]).size;

    // console.log("[localStorage] state size: ", byteSize);

    localStorage.setItem("state", serializedState);
  } catch (err) {
    console.error("Failure in saveState", err);
    return undefined;
  }
};

export const deleteState = () => {
  localStorage.removeItem("state");
};

const EXTENSION_LOGOUT_TRIGGERED = "EXTENSION_LOGOUT_TRIGGERED";
const SELECTED_POLICY_KEY = "SELECTED_POLICY_KEY";

export const setExtensionLogoutFlag = () => {
  sessionStorage.setItem(EXTENSION_LOGOUT_TRIGGERED, "true");
};

export const clearExtensionLogoutFlag = () => {
  sessionStorage.removeItem(EXTENSION_LOGOUT_TRIGGERED);
};

export const getExtensionLogoutFlag = (): boolean => {
  const value = sessionStorage.getItem("EXTENSION_LOGOUT_TRIGGERED");
  return value ? value === "true" : false;
};

export const saveSelectedPolicyId = (policyId: string | null) => {
  if (policyId) {
    localStorage.setItem(SELECTED_POLICY_KEY, policyId);
  } else {
    localStorage.removeItem(SELECTED_POLICY_KEY);
  }
};

export const getSelectedPolicyId = (): string | null => {
  return localStorage.getItem(SELECTED_POLICY_KEY);
};

const PUBLIC_POLICY_STUDIO_STATE = "PUBLIC_POLICY_STUDIO_STATE";

export const savePublicPolicyStudioState = (state: any) => {
  localStorage.setItem(PUBLIC_POLICY_STUDIO_STATE, JSON.stringify(state));
};

export const getPublicPolicyStudioState = (): any => {
  const value = localStorage.getItem(PUBLIC_POLICY_STUDIO_STATE);
  return value ? JSON.parse(value) : null;
};

export const deletePublicPolicyStudioState = () => {
  localStorage.removeItem(PUBLIC_POLICY_STUDIO_STATE);
};
